import { SentryLogger } from "@utils/sentry/sentryLogger";

export const logger = new SentryLogger();
